import { render, staticRenderFns } from "./SiteRolesPage.vue?vue&type=template&id=0b64d547&scoped=true"
import script from "./SiteRolesPage.vue?vue&type=script&lang=js"
export * from "./SiteRolesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b64d547",
  null
  
)

export default component.exports